import { render, staticRenderFns } from "./payment_statement.vue?vue&type=template&id=620bcc3c&scoped=true"
import script from "./payment_statement.vue?vue&type=script&lang=ts"
export * from "./payment_statement.vue?vue&type=script&lang=ts"
import style0 from "./payment_statement.vue?vue&type=style&index=0&id=620bcc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bcc3c",
  null
  
)

export default component.exports